import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.css']
})
export class AlertModalComponent {

  @Input() public message : any;
  @Input() public ConfirmbtnLabel : any;
  @Input() public ClosebtnLabel : any;


  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  constructor(private modalService: NgbModal, public activeModal: NgbActiveModal) {

  }

  

  async closeModal() {
    this.close.emit();
  }

  async onSubmit() {
    this.passEntry.emit({
      data: "confirm-submit"
    });
  }
}
